import React, { Dispatch, Fragment, SetStateAction, useEffect, useState } from 'react';
import '../../../../../assets/scss/preview.css';
import { safObjectHelper } from '../../../../../utils/SafObjectHelper.ts';
import { companyApi } from '../../../../../modules';
import { codeApi } from '../../../../../api/code.api.ts';

interface IProps {
  ref?: any;
  formCode?: string;
  section?: any;
  data: any;
}

const View = (props: IProps) => {
  const [companyName, setCompanyName] = useState<any>();
  const [disciplineName, setDisciplineName] = useState<any>();
  const [manpowerOptions, setManpowerOptions] = useState<any>([]);
  useEffect(() => {
    codeApi.getManpowerCodeList().then((list) => {
      setManpowerOptions(list);
    });
  }, []);
  useEffect(() => {
    if (!props.data?.companyId) return;
    companyApi.getCompanyName({ companyId: props.data.companyId }).then((res) => {
      setCompanyName(res.resultObject.companyName);
    });
  }, [props.data?.companyId]);
  useEffect(() => {
    if (!props.data?.companyId) return;
    codeApi.getCodeDetail(props.data.disciplineCd).then((res) => {
      setDisciplineName(res.codeName);
    });
  }, [props.data?.disciplineCd]);
  useEffect(() => {
    console.log(props.data?.manPower);
  }, [props.data?.manPower]);
  return (
    <div>
      <table className={'preview-table'}>
        <colgroup>
          <col width={'5%'} />
          <col width={'5%'} />
          <col width={'5%'} />
          <col width={'5%'} />
          <col width={'5%'} />
          <col width={'5%'} />
          <col width={'5%'} />
          <col width={'5%'} />
          <col width={'5%'} />
          <col width={'5%'} />
          <col width={'10%'} />
          <col width={'10%'} />
          <col width={'10%'} />
          <col width={'10%'} />
        </colgroup>
        <tbody>
          <tr>
            <th colSpan={3}>Work Location / Area : </th>
            <td colSpan={7}>{props.data?.locationText}</td>
            <th>COMPANY</th>
            <td className={'saf-td-center'}>{companyName}</td>
            <th>DISCIPLINE</th>
            <td className={'saf-td-center'}>{disciplineName}</td>
          </tr>
          <tr>
            <th rowSpan={2}>Work Duration</th>
            <th>Date</th>
            <th>From</th>
            <td colSpan={3} className={'saf-td-center'}>
              {safObjectHelper.formatDate(props.data?.validStartTime)}
            </td>
            <th>To</th>
            <td colSpan={3} className={'saf-td-center'}>
              {safObjectHelper.formatDate(props.data?.validEndTime)}
            </td>
            <td rowSpan={4} colSpan={4} className={'saf-border-bottom-none'}>
              <div className={'saf-no-wrap preview-text-01'}>Job Description :</div>
              <div>{props.data?.description}</div>
            </td>
          </tr>
          <tr>
            <th>Time</th>
            <th>From</th>
            <td colSpan={3} className={'saf-td-center'}>
              {safObjectHelper.formatTime(props.data?.validStartTime)}
            </td>
            <th>To</th>
            <td colSpan={3} className={'saf-td-center'}>
              {safObjectHelper.formatTime(props.data?.validEndTime)}
            </td>
          </tr>
          <tr>
            <th rowSpan={2} className={'saf-border-bottom-none'}>
              Manpower Planning
            </th>
            <th>Total</th>
            <th>SV</th>
            <th>HSE</th>
            <th>Operator</th>
            <th>Rigger</th>
            <th>Foreman</th>
            <th>Worker</th>
            <th>F.Wacther</th>
            <th>Etc.</th>
          </tr>
          <tr>
            <td className={'saf-td-center'}>
              &nbsp;{safObjectHelper.totalManPower(props.data?.manPower)}&nbsp;
            </td>
            <td className={'saf-td-center'}>
              {safObjectHelper.calcManPower(props.data?.manPower, 'SV', manpowerOptions)}
            </td>
            <td className={'saf-td-center'}>
              {safObjectHelper.calcManPower(props.data?.manPower, 'HSE', manpowerOptions)}
            </td>
            <td className={'saf-td-center'}>
              {safObjectHelper.calcManPower(props.data?.manPower, 'Operator', manpowerOptions)}
            </td>
            <td className={'saf-td-center'}>
              {safObjectHelper.calcManPower(props.data?.manPower, 'Rigger', manpowerOptions)}
            </td>
            <td className={'saf-td-center'}>
              {safObjectHelper.calcManPower(props.data?.manPower, 'Foreman', manpowerOptions)}
            </td>
            <td className={'saf-td-center'}>
              {safObjectHelper.calcManPower(props.data?.manPower, 'Worker', manpowerOptions)}
            </td>
            <td className={'saf-td-center'}>
              {safObjectHelper.calcManPower(props.data?.manPower, 'F.Wacther', manpowerOptions)}
            </td>
            <td className={'saf-td-center'}>
              {safObjectHelper.calcManPower(props.data?.manPower, 'Etc.', manpowerOptions)}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default View;
